module.exports = __webpack_public_path__ + "img/2.96621cf4.svg";